import type { ReactNode } from "react";

import { cn } from "../../lib/utils.js";

export interface AuthShellProps {
  brand?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * Centered, slick auth shell. Drops a subtle dotted background so a
 * raw <SignInForm /> still looks like a polished page.
 */
export const AuthShell = ({ brand, footer, children, className }: AuthShellProps) => (
  <div
    className={cn(
      "relative flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 py-12",
      "before:absolute before:inset-0 before:-z-10 before:bg-[radial-gradient(circle_at_1px_1px,hsl(var(--border))_1px,transparent_0)] before:bg-[size:24px_24px] before:opacity-50",
      className
    )}
  >
    {brand ? <div className="text-sm font-semibold tracking-tight">{brand}</div> : null}
    {children}
    {footer ? <div className="text-xs text-muted-foreground">{footer}</div> : null}
  </div>
);
